import { render, staticRenderFns } from "./dialogWangdian.vue?vue&type=template&id=35cbf0a2&scoped=true"
import script from "./dialogWangdian.vue?vue&type=script&lang=js"
export * from "./dialogWangdian.vue?vue&type=script&lang=js"
import style0 from "./dialogWangdian.vue?vue&type=style&index=0&id=35cbf0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbf0a2",
  null
  
)

export default component.exports